import { SelectResult } from '../components/select/select-chain.component';
import { MutationKeyConfig, QueryKeyConfig } from './api-helper';

export interface FastFieldQueueArgs {
  customerID?: number;
  officeID?: number;
  projectID?: number;
  unitID?: number;
  serviceID?: number;
  inspectorID?: number;
  wOStatusID?: number;
  dateFrom?: string;
  dateTo?: string;
  dateCriteria?: string;
  duxInspectionRequestType?: number;
  projectStatus?: string;
  showAll?: string;
  // scheduledDateFrom?:string;
  // scheduledDateTo?:string;
}

const getFastFieldQueueWithFilters = (filter: FastFieldQueueArgs) => {
  const {
    customerID,
    officeID,
    projectID,
    unitID,
    serviceID,
    inspectorID,
    wOStatusID,
    dateFrom,
    dateTo,
    duxInspectionRequestType,
    projectStatus,
    dateCriteria,
  } = filter;

  let queryString = '';

  if (customerID) {
    queryString += `${queryString ? '&' : ''}CustomerID=${customerID}`;
  }
  if (officeID) {
    queryString += `${queryString ? '&' : ''}OfficeID=${officeID}`;
  }
  if (projectID) {
    queryString += `${queryString ? '&' : ''}ProjectID=${projectID}`;
  }
  if (unitID) {
    queryString += `${queryString ? '&' : ''}UnitID=${unitID}`;
  }
  if (serviceID) {
    queryString += `${queryString ? '&' : ''}ServiceID=${serviceID}`;
  }
  if (inspectorID) {
    queryString += `${queryString ? '&' : ''}InspectorID=${inspectorID}`;
  }
  if (wOStatusID) {
    queryString += `${queryString ? '&' : ''}WOStatusID=${wOStatusID}`;
  }
  if (dateFrom) {
    queryString += `${queryString ? '&' : ''}DateFrom=${dateFrom}`;
  }
  if (dateTo) {
    queryString += `${queryString ? '&' : ''}DateTo=${dateTo}`;
  }
  if (duxInspectionRequestType) {
    queryString += `${queryString ? '&' : ''}DuxInspectionRequestType=${duxInspectionRequestType}`;
  }
  if (dateCriteria) {
    queryString += `${queryString ? '&' : ''}DateCriteria=${dateCriteria}`;
  }
  if (projectStatus) {
    queryString += `${queryString ? '&' : ''}ProjectStatus=${projectStatus}`;
  }
  return queryString;
};

const getWorkOrdersWithFilters = (filter: any) => {
  if (filter) {
    const { customerID, officeID, projectID, unitID, workOrderStatusID, searchText } = filter;
    if (unitID) {
      return `/workorder?customerID=${!customerID ? 0 : customerID}&unitID=${unitID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}`;
    }
    if (projectID) {
      return `/workorder?customerID=${!customerID ? 0 : customerID}&projectID=${projectID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}`;
    }
    if (officeID) {
      return `/workorder?customerID=${!customerID ? 0 : customerID}&officeID=${officeID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}`;
    }
    if (customerID) {
      return `/workorder?customerID=${customerID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}`;
    }
    if (searchText) {
      return `/workorder?SearchText=${searchText}`;
    }
  }

  return `/workorder`;
};

const getWorkOrdersWithFiltersWithPagination = (filter: any, pageNumber: number, pageSize: number) => {
  if (filter) {
    const { customerID, officeID, projectID, unitID, workOrderStatusID, searchText } = filter;
    if (unitID) {
      return `/workorder?unitID=${unitID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}`;
    }
    if (projectID) {
      return `/workorder?projectID=${projectID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
    }
    if (officeID) {
      return `/workorder?officeID=${officeID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
    }
    if (customerID) {
      return `/workorder?customerID=${customerID}&workOrderStatusID=${!workOrderStatusID ? '' : workOrderStatusID}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
    }
    if (searchText) {
      return `/workorder?SearchText=${searchText}&PageNumber=${pageNumber}&PageSize=${pageSize}`;
    }
  }

  return `/workorder?PageNumber=${pageNumber}&PageSize=${pageSize}`;
};

const getGeneralWorkOrdersWithFilters = (filter?: any) => {
  if (filter) {
    const { customerID, officeID, projectID, unitID } = filter;
    if (unitID) {
      return `/workorder/general?unitID=${unitID}`;
    }
    if (projectID) {
      return `/workorder/general?projectID=${projectID}`;
    }
    if (officeID) {
      return `/workorder/general?officeID=${officeID}`;
    }
    if (customerID) {
      return `/workorder/general?customerID=${customerID}`;
    }
  }

  return `/workorder/general`;
};

export const workOrdersApiKeyStore = {
  getWorkOrders: (selectedFilters?: SelectResult): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDERS`, selectedFilters],
    route: getWorkOrdersWithFilters(selectedFilters),
  }),
  getWorkOrdersWithPagination: (
    pageNumber: number,
    pageSize: number,
    selectedFilters?: SelectResult
  ): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDERS`, selectedFilters],
    route: getWorkOrdersWithFiltersWithPagination(selectedFilters, pageNumber, pageSize),
  }),
  getGeneralWorkOrders: (selectedFilters?: SelectResult): QueryKeyConfig => ({
    queryKey: [`GET_GENERAL_WORKORDERS`, selectedFilters],
    route: getGeneralWorkOrdersWithFilters(selectedFilters),
  }),
  getWorkOrderStatuses: (type: string): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDERSTATUS`],
    route: `/workorder/${type}/status`,
  }),
  getWorkOrderNumbers: (): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDER_NUMBER`],
    route: `/WorkOrder/WorkorderFilter`,
  }),
  getGeneralWODetails: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_GENERALWO_DETAILS`, workorderID],
    route: `/workorder/GeneralWO/${workorderID}`,
  }),
  getWorkorderDetails: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDER_DETAILS`, workorderID],
    route: `/WorkOrder/${workorderID}`,
  }),
  getPurchaseOrder: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_PURCHASE_ORDER`, workorderID],
    route: `/workorder/${workorderID}/PurchaseOrder`,
    isEnabled: workorderID !== undefined && workorderID !== null,
  }),
  getUnitWorkOrders: (unitID: number): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_WORKORDERS`, unitID],
    route: `/workorder?unitID=${unitID}`,
  }),
  getWorkOrderStatus: (type: string): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDERS_STATUS`, type],
    route: `/Workorder/${type}/status`,
  }),

  getScheduleBalancingStatus: (): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDERS_SHEDULE_BALANCE_STATUS`],
    route: `/Workorder/ScheduleBalancingFilter/Status`,
  }),

  scheduleWorkOrder: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WORK_ORDER`],
    route: `/workorder/schedule`,
    action: 'PUT',
  }),
  updateWorkOrderStatus: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WORK_ORDER_STATUS`],
    route: `/workorder/status`,
    action: 'PUT',
  }),
  updateWorkOrderHours: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WORK_ORDER_HOURS`],
    route: `/WorkOrder/WorkedHours`,
    action: 'PUT',
  }),
  updateGeneralWorkOrder: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_GENERAL_WORK_ORDER`],
    route: `/workorder/general`,
    action: 'PUT',
  }),
  updatePurchaseOrder: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_PURCHASE_ORDER`],
    route: `/workorder/UploadPurchaseOrder`,
    action: 'PUT',
  }),
  generateWorkOrder: (): MutationKeyConfig => ({
    mutationKey: [`GENERATE_WO`],
    route: `/workorder`,
    action: 'POST',
  }),
  deleteWorkOrder: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_WORK_ORDER`],
    route: `/workorder/${id}`,
    action: 'DELETE',
  }),
  deletePurchaseOrder: (purchaseOrderID: any): MutationKeyConfig => ({
    mutationKey: [`DELETE_PURCHASE_ORDER_BY_ID`, purchaseOrderID],
    route: `/Workorder/${purchaseOrderID}/PurchaseOrder`,
    action: 'DELETE',
  }),
  workOrderInspections: (): MutationKeyConfig => ({
    mutationKey: [`_WORKORDER_INSPECTIONS`],
    route: `/workorder/inspections`,
    action: 'POST',
    disableSnackbar: true,
  }),
  bulkSchedule: (): MutationKeyConfig => ({
    mutationKey: [`BULK_SCHEDULE`],
    route: `/workorder/bulkschedule`,
    action: 'PUT',
    disableSnackbar: true,
  }),
  getBlobSasToken: (): QueryKeyConfig => ({
    queryKey: [`GET_BLOB_SAS_TOKEN`],
    route: `/WorkOrder/BlobSASToken`,
  }),
  updateWorkOrder: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WORK_ORDER`],
    route: `/workorder`,
    action: 'PUT',
  }),
  switchService: (): MutationKeyConfig => ({
    mutationKey: [`SWITCH_WO_SERVICE`],
    route: `/workorder/Switch`,
    action: 'PUT',
  }),
  getPurchaseOrderList: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_PURCHASE_ORDER_LIST`, workorderID],
    route: `/Workorder/${workorderID}/PurchaseOrderList`,
  }),

  fastFieldDispatch: (woid: any, shtype: any): MutationKeyConfig => ({
    mutationKey: [`FASTFIELD_DISPATCH`],
    route: `&woid=${woid}&shtype=${shtype}`,
    action: 'POST',
  }),

  fastFieldRecall: (woid: any): MutationKeyConfig => ({
    mutationKey: [`FASTFIELD_RECALL`],
    route: `&woid=${woid}`,
    action: 'POST',
  }),

  getWOFileList: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_WO_FILE_LIST`, workorderID],
    route: `/File?WorkOrderID=${workorderID}&IsSystemGenerated=true`,
  }),

  getServiceMappingListForWorkorder: (
    customerID: any,
    officeID: any,
    projectID: any,
    unitID: any,
    municipalityID: any
  ): QueryKeyConfig => ({
    queryKey: [`GET_SERVICES_MAPPING_LIST`, officeID, customerID, projectID, unitID, municipalityID],
    route: `/Service/MappingList?ProjectID=${projectID}&OfficeID=${officeID}&CustomerID=${customerID}&UnitID=${unitID}&MunicipalityID=${municipalityID}`,
    isEnabled: unitID >= 0,
  }),

  // generateWorkOrderSheduleRules: (): MutationKeyConfig => ({
  //   mutationKey: [`GENERATE_WO_SHEDULE_RULES`],
  //   route: `/workorder/ScheduleRules`,
  //   action: 'POST',
  //   disableSnackbar: true,
  // }),

  checkWorkOrderSheduleRules: (): MutationKeyConfig => ({
    mutationKey: [`CHECK_WO_SHEDULE_RULES`],
    route: `/workorder/CheckPendingScheduleValidation`,
    action: 'POST',
    disableSnackbar: true,
  }),

  updateReasonForFeeWaived: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WORK_REASON_FOR_FEEWAIVED`],
    route: `/WorkOrder/FeeWaive`,
    action: 'PUT',
  }),
  generateNewWorkOrder: (): MutationKeyConfig => ({
    mutationKey: [`GENERATE_NEW_WO `],
    route: `/WorkOrder/GenerateWorkOrders`,
    action: 'POST',
    disableSnackbar: true,
  }),
  getUnitWorkOrdersWithPagination: (unitID: number, pageNumber: number, pageSize: number): QueryKeyConfig => ({
    queryKey: [`GET_UNIT_WORKORDERS`, unitID],
    route: `/workorder?unitID=${unitID}&PageNumber=${pageNumber}&PageSize=${pageSize}`,
  }),
  getTimeandMaterialDetails: (workorderID: number): QueryKeyConfig => ({
    queryKey: [`GET_TIME_MATERIALS_DETAILS`, workorderID],
    route: `/workorder/TimeandMaterialDetails/${workorderID}`,
  }),
  deleteTimeandMaterial: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_TIME_AND_METERIAL`],
    route: `/workorder/TimeandMaterialDetails/${id}`,
    action: 'DELETE',
  }),
  updateTimeAndMeterial: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_WORK_ORDER_TIME_AND_METERIA`],
    route: `/workorder/TimeandMaterialDetails`,
    action: 'POST',
  }),
  getWorkOrderByFilters: (): MutationKeyConfig => ({
    mutationKey: [`GET_WORK_ORDER_BY_FILTERS`],
    route: `/WorkOrder/GetAllWorkOrders`,
    action: 'POST',
    disableSnackbar: true,
  }),
  updateProposedScheduleDate: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_PROPOSED_SCHEDULE_DATE`],
    route: `/WorkOrder/ChangeProposedScheduleDate`,
    action: 'PUT',
  }),
  qBOInvoiceGenerationRetry: (): MutationKeyConfig => ({
    mutationKey: [`QB_INVOICE_GENERATE_RETRY`],
    route: `/WorkOrder/QBOInvoiceGenerationRetry`,
    action: 'POST',
  }),

  deleteInvoiceException: (): MutationKeyConfig => ({
    mutationKey: [`DELETE_INVOICE_EXCEPTION`],
    route: `/WorkOrder/InvoiceException`,
    action: 'PUT',
  }),
  // QUICBOOK_INVOICE_REPORT: (woid: any, invoiceAmount: any, invoiceID: any): MutationKeyConfig => ({
  //   mutationKey: [`QUICBOOK_INVOICE_REPORT`],
  //   route: `QuickBookInvoiceUpdate?InvoiceAmount=${invoiceAmount}&QBOInvoiceID=${invoiceID}&WorkOrderID=${woid}`,
  //   action: 'POST',
  // }),

  QUICBOOK_INVOICE_REPORT: (): MutationKeyConfig => ({
    mutationKey: [`QUICBOOK_INVOICE_REPORT`],
    //route: `/QuickBookInvoiceUpdate`,
    route: ``,
    action: 'POST',
  }),
  getInspectionRequestType: (): QueryKeyConfig => ({
    queryKey: [`GET_INSPECTION_REQUEST_TYPE`],
    route: `/WorkOrder/InspectionRequestType`,
  }),
  declinedWorkOrder: (): MutationKeyConfig => ({
    mutationKey: [`DECLINED_WORK_ORDER`],
    route: `/WorkOrder/DeclineDuxRequest`,
    action: 'PUT',
  }),
  hasPreRequisitesForReady: (): MutationKeyConfig => ({
    mutationKey: [`HAS_PRE_REQUESTIES_FOR_READY`],
    route: `/WorkOrder/HasPreRequisitesForReady`,
    action: 'PUT',
    disableSnackbar: true,
    disableFailSnackbar: true,
  }),
  updateScheduleEmail: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_SCHEDULE_EMAIL_RESPONSE`],
    route: `/WorkOrder/UpdateWOScheduleEmailResponse`,
    action: 'POST',
    disableSnackbar: true,
    disableFailSnackbar: true,
  }),
  getFastFieldReprocessQueue: (args: FastFieldQueueArgs): QueryKeyConfig => ({
    queryKey: [
      `GET_FAST_FIELD_REPROCESS_QUEUE`,
      [
        args.customerID,
        args.officeID,
        args.projectID,
        args.unitID,
      ].filter((a) => a),
    ],
    route: `/WorkOrder/GetFastFieldReprocessQueue?${getFastFieldQueueWithFilters(args)}`,
  }),
  startFastFieldReprocessQueue: (): MutationKeyConfig => ({
    mutationKey: [`START_FAST_FIELD_REPORCESS_QUEUE`],
    route: `/WorkOrder/StartFastFieldReprocessQueue`,
    action: 'POST',
  }),
  workOrderDuxSMS: (): MutationKeyConfig => ({
    mutationKey: [`WORK_ORDER_DUX_SMS`],
    route: `/WorkOrder/SendDuxSms`,
    action: 'POST',
  }),
  validateWorkOrderSheduleRules: (): MutationKeyConfig => ({
    mutationKey: [`WORK_ORDER_SCHEDULE_RULES`],
    route: `/WorkOrder/CheckSchedulingRules`,
    action: 'POST',
    disableSnackbar: true
  }),
  checkPrerequisitesBeforeReady: (): MutationKeyConfig => ({
    mutationKey: [`CHECK_PREREQUISITES_BEFORE_READY`],
    route: `/WorkOrder/CheckPrerequisitesBeforeReady`,
    action: 'POST',
    disableSnackbar: true
  }),
  workOrderInspectorInspectionCounts: (): MutationKeyConfig => ({
    mutationKey: [`WORK_ORDER_INSPECTOR_COUNTS`],
    route: `/WorkOrder/InspectorInspectionCounts`,
    action: 'POST',
    disableSnackbar: true
  }),
  getWorkOrderReasons: (): QueryKeyConfig => ({
    queryKey: [`GET_WORKORDER_REASONS`],
    route: `/WorkOrder/ChangeReasons`,
  }),
};
